import { Input } from '@/src/common/components/Input'
import { type FieldValues, useController } from 'react-hook-form'
import {
  type ComponentProps,
  type ComponentRef,
  forwardRef,
  type Ref,
  useImperativeHandle,
  useRef,
} from 'react'
import { formatCurrency } from '@/src/common/utils/general'
import type { TextInput } from 'react-native'
import { useEvent } from 'tamagui'
import type {
  FormInputProps,
  FormInputType,
} from '@/src/experiences/card-application/components/form-input'

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const FormInputCurrency = forwardRef(function FormInputCurrency<T extends FieldValues>(
  { control, name, sardineId, ...props }: FormInputProps<T>,
  ref: Ref<TextInput | null>,
) {
  const { field, fieldState, formState } = useController({ control, name })
  const localRef = useRef<TextInput>(null)
  const info = props.info ?? {}
  // TODO: Segment Integration

  // @ts-expect-error type differences between Ref.current and Ref
  // going to ignore for now
  useImperativeHandle(ref, () => localRef.current)
  useImperativeHandle(field.ref, () => localRef.current)

  const handleChangeText: NonNullable<ComponentProps<typeof Input>['onChangeText']> = useEvent(
    (value) => {
      field.onChange(value.replace(/[^0-9]/g, ''))
      field.onBlur()
    },
  )

  const handleBlur: NonNullable<ComponentProps<typeof Input>['onBlur']> = useEvent((...args) => {
    field.onBlur()
    props.onBlur?.(...args)
  })

  return (
    <Input
      keyboardType="numeric"
      {...props}
      sardineId={sardineId}
      value={formatCurrency(`${field.value}`, {
        decimals: 0,
        minimumFractionDigits: 0,
      })}
      onChangeText={handleChangeText}
      info={{
        ...info,
        error: formState.isValidating ? undefined : fieldState.error?.message,
      }}
      onBlur={handleBlur}
      ref={localRef}
    />
  )
}) as FormInputType<ComponentRef<typeof Input>>
